import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = number;

type ResponseData = SuccessRO;

export const addMissingLanguages: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/translations/missing-language/add/${id}`,
    method: 'GET',
});
